import React from 'react'
import { connect} from 'react-redux'
import { bindActionCreators } from 'redux'
import * as notificationActions from '../modules/notificationActionCreators'
import MainTabBar from '../components/MainTabBar/MainTabBar'

class MainTabBarContainer extends React.Component {

  componentDidMount() {
    this.props.fetchNotifications()
  }

  render() {
    return <MainTabBar {...this.props} />
  }
}

const mapStateToProps = state => {
  return {
    unreadChatrooms: state.notification.unreadChatrooms,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchNotifications: notificationActions.fetchNotifications,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MainTabBarContainer)



// WEBPACK FOOTER //
// ./src/containers/MainTabBarContainer.js